#import "../fragments/email-automation-statuses-fragment.graphql"

mutation StartPersonalEmailSequence($input: EmailAutomationStatusManualStartInput!) {
    emailAutomationStatusManualStart(input: $input) {
        emailAutomationStatus {
            ...EmailAutomationStatusesFragment
        }
    }
}
